import {DateRange, EmptyDateRange} from 'Core/models/DateRange';

export type AgentNewsFilter = {
  title: string;
  description: string;
  publishDate: DateRange;
  pageNumber: string;
  pageSize: string;
};

export const EmptyAgentNewsFilter = {
  title: '',
  description: '',
  publishDate: EmptyDateRange,
  pageNumber: '1',
  pageSize: '25',
};
